import type { ICustomControlProcedureReadProps } from '../../interfaces/';
import { ProcedureThumbnails } from '../../utils/v1/ProcedureThumbnails';

export function DermaOthV1ProcedureSummary(props: ICustomControlProcedureReadProps) {
    return <ProcedureThumbnails {...props} />;
}
